import { SectionLabel, FadeUp } from "@/components/Reveal";
import VesselPattern from "@/components/VesselPattern";
import { useLang } from "@/i18n/LanguageContext";

const Experience = () => {
  const { t } = useLang();
  return (
  <section
    id="experience"
    data-testid="experience-section"
    className="relative overflow-hidden bg-ivory text-midnight"
  >
    <VesselPattern
      className="pointer-events-none absolute bottom-0 left-0 h-2/3 w-1/3"
      stroke="#0D0D0D"
      opacity={0.05}
    />
    <div className="mx-auto max-w-[1680px] px-6 py-20 lg:px-12 lg:py-32">
      <SectionLabel index="03" text={t.experience.label} light />
      <FadeUp delay={0.1}>
        <h2 className="mt-8 max-w-3xl font-serif text-4xl font-light leading-[1.1] md:text-5xl lg:text-6xl">
          {t.experience.pre}
          <span className="italic text-[#8a6f45]">{t.experience.em}</span>
          {t.experience.post}
        </h2>
      </FadeUp>

      <div className="mt-16 grid gap-0 lg:grid-cols-5 lg:gap-8">
        {t.experience.steps.map((s, i) => (
          <FadeUp
            key={s.n}
            delay={i * 0.1}
            className="relative border-l border-gold/40 pb-9 pl-8 lg:border-l-0 lg:border-t lg:pb-0 lg:pl-0 lg:pt-10"
            data-testid={`experience-step-${s.n}`}
          >
            <span
              className="absolute -left-[5px] top-1 h-[9px] w-[9px] rotate-45 bg-gold lg:-top-[5px] lg:left-0"
              aria-hidden="true"
            />
            <p className="hv-nums font-serif text-5xl font-light text-[#8a6f45]/70">{s.n}</p>
            <h3 className="mt-5 font-sans text-xs tracking-[0.35em] text-midnight">
              {s.title.toUpperCase()}
            </h3>
            <p className="mt-4 max-w-[240px] font-sans text-sm font-light leading-relaxed text-midnight/60">
              {s.desc}
            </p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Experience;
